import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot",
  "use": "icon-dot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dot\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M512 426.666667c47.125333 0 85.333333 38.208 85.333333 85.333333s-38.208 85.333333-85.333333 85.333333c-47.125333 0-85.333333-38.208-85.333333-85.333333S464.874667 426.666667 512 426.666667z\" p-id=\"4876\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol